import React, { useState } from 'react';
import { collection, addDoc, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase';

const initialState = {
    fullName: '',
    mobileNo: '',
    companyName: '',
    emailId: '',
    verified: false,
};

const AddOrEditHRContact = ({ contact, onClose }) => {
    const [form, setForm] = useState(contact || initialState);
    const [saving, setSaving] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        if (contact && contact.id) {
            await updateDoc(doc(db, 'hrContacts', contact.id), form);
        } else {
            await addDoc(collection(db, 'hrContacts'), form);
        }
        setSaving(false);
        onClose(true);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 animate-fadeIn">
            <form
                className="bg-white rounded-xl shadow-2xl p-4 w-full max-w-xs relative animate-slideUp"
                onSubmit={handleSubmit}
            >
                <h3 className="text-xl font-extrabold mb-4 text-[#0071bd] text-center tracking-tight drop-shadow">{contact ? 'Edit' : 'Add'} HR Contact</h3>
                <div className="grid grid-cols-1 gap-3">
                    <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1">Full Name<span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="fullName"
                            value={form.fullName}
                            onChange={handleChange}
                            required
                            className="mt-1 block w-full rounded-lg border border-gray-300 shadow focus:ring-2 focus:ring-[#0071bd] focus:border-[#0071bd] transition-all duration-200 px-2 py-1 text-base"
                            placeholder="Enter full name"
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1">Mobile No<span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="mobileNo"
                            value={form.mobileNo}
                            onChange={handleChange}
                            required
                            className="mt-1 block w-full rounded-lg border border-gray-300 shadow focus:ring-2 focus:ring-[#0071bd] focus:border-[#0071bd] transition-all duration-200 px-2 py-1 text-base"
                            placeholder="Enter mobile number"
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-semibold text-gray-700 mb-1">Company Name<span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            name="companyName"
                            value={form.companyName}
                            onChange={handleChange}
                            required
                            className="mt-1 block w-full rounded-lg border border-gray-300 shadow focus:ring-2 focus:ring-[#0071bd] focus:border-[#0071bd] transition-all duration-200 px-2 py-1 text-base"
                            placeholder="Enter company name"
                        />
                    </div>
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1">Email ID <span className="text-xs text-gray-400">(optional)</span></label>
            <input
              type="email"
              name="emailId"
              value={form.emailId}
              onChange={handleChange}
              className="mt-1 block w-full rounded-lg border border-gray-300 shadow focus:ring-2 focus:ring-[#0071bd] focus:border-[#0071bd] transition-all duration-200 px-2 py-1 text-base"
              placeholder="Enter email address"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1">Note <span className="text-xs text-gray-400">(optional)</span></label>
            <textarea
              name="note"
              value={form.note || ''}
              onChange={handleChange}
              className="mt-1 block w-full rounded-lg border border-gray-300 shadow focus:ring-2 focus:ring-[#0071bd] focus:border-[#0071bd] transition-all duration-200 px-2 py-1 text-base min-h-[48px]"
              placeholder="Add a note for this HR contact (will show on card)"
            />
          </div>
                    <div className="flex items-center gap-3 mt-2">
                        <span className="text-xs font-semibold text-gray-700">Is Contacted</span>
                        <label className="relative inline-flex items-center cursor-pointer select-none">
                            <input
                                type="checkbox"
                                name="verified"
                                checked={form.verified}
                                onChange={handleChange}
                                className="sr-only peer"
                            />
                            <div className="w-14 h-8 bg-gray-300 rounded-full shadow-inner"></div>
                            <div
                                className={`absolute left-0.5 top-0.5 w-6 h-6 rounded-full transition-transform duration-200 ease-in-out ${form.verified ? "translate-x-full bg-[#0071bd]" : "bg-gray-500"
                                    }`}
                            ></div>
                        </label>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-6">
                    <button
                        type="button"
                        className="px-4 py-1 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 font-semibold transition-all duration-200 shadow"
                        onClick={() => onClose(false)}
                        disabled={saving}
                    >Cancel</button>
                    <button
                        type="submit"
                        className="px-5 py-1 rounded-lg bg-[#0071bd] text-white hover:bg-[#005fa3] font-bold shadow-lg transition-all duration-200"
                        disabled={saving}
                    >{saving ? 'Saving...' : (contact ? 'Update' : 'Add')}</button>
                </div>
            </form>
        </div>
    );
};

export default AddOrEditHRContact;
